function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_CUSTOMER_CHALLENGE_ANSWER = {
  BEGIN: 'RETRIEVE_CUSTOMER_CHALLENGE_ANSWER_BEGIN',
  SUCCESS: 'RETRIEVE_CUSTOMER_CHALLENGE_ANSWER_SUCCESS',
  FAILURE: 'RETRIEVE_CUSTOMER_CHALLENGE_ANSWER_FAILURE'
};
var RETRIEVE_CUSTOMER_CHALLENGE_ANSWER_EVENTS = [RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.BEGIN, RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.SUCCESS, RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.FAILURE];
export var customerChallengeAnswerPromise = function customerChallengeAnswerPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_CUSTOMER_CHALLENGE_ANSWER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveChallengeAnswer',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    /* so the reducer knows the customer Id */
    customerId: customerId
  });
};
export var retrieveCustomerChallengeAnswer = function retrieveCustomerChallengeAnswer(customerId) {
  return function (dispatch) {
    return customerChallengeAnswerPromise(dispatch, customerId);
  };
};